<template>
  <v-container fill-height style="min-height: calc(100vh - 80px);">
    <v-row>
      <v-col cols="12" md="12" class="align-self-center">
        <v-card outlined>
          <v-card-text>
            <v-row justify="center" class="black--text">
              <v-col cols="12" md="5">
                <div class="mb-5">
                  <h2 class="text-md-h5">
                    Contact Information
                  </h2>
                </div>
                <div class="mb-3">
                  <div class="foot-list-icon float-left">
                    <v-icon :color="maincolor">
                      mdi-map-marker
                    </v-icon>
                  </div>
                  <div class="foot-list-content">
                    <strong>Career Center <br/>Politeknik Negeri Bali</strong> <br/>
                    Uluwatu St No.45, Jimbaran, South Kuta, Badung Regency, Bali 80361
                  </div>
                </div>
                <div class="mb-3">
                  <div class="foot-list-icon float-left">
                    <v-icon :color="maincolor">
                      phone
                    </v-icon>
                  </div>
                  <div class="foot-list-content">
                    +62 (0361)701981
                  </div>
                </div>
                <div class="mb-5">
                  <div class="foot-list-icon float-left">
                    <v-icon :color="maincolor">
                      email
                    </v-icon>
                  </div>
                  <div class="foot-list-content">
                    poltek@pnb.ac.id
                  </div>
                </div>
                <div>
                  <v-divider></v-divider>
                </div>
                <div class="mt-5">
                  <v-btn
                    class="mr-2"
                    small
                    fab
                    outlined
                    :color="maincolor">
                    <v-icon :color="maincolor">
                      mdi-facebook
                    </v-icon>
                  </v-btn>
                  <v-btn
                    class="mr-2"
                    small
                    fab
                    outlined
                    :color="maincolor">
                    <v-icon :color="maincolor">
                      mdi-instagram
                    </v-icon>
                  </v-btn>
                  <v-btn
                    class="mr-2"
                    small
                    fab
                    outlined
                    :color="maincolor">
                    <v-icon :color="maincolor">
                      mdi-linkedin
                    </v-icon>
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12" md="1" v-show="!$vuetify.breakpoint.smAndDown">
                <v-divider vertical></v-divider>
              </v-col>
              <v-col cols="12" md="5">
                <div class="mb-5">
                  <h2 class="text-md-h5">
                    Get in Touch
                  </h2>
                  <p>
                    Got a question? We'd love to here from you. Send us a message and we'll response as soon as possible.
                  </p>
                </div>
                <alertsp :alertdata="alertdata"></alertsp>
                <v-form
                  @submit.prevent="submitContact"
                  ref="formcontact"
                  v-model="formin.valid"
                  lazy-validation>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-text-field
                        dense
                        v-model="contact.name"
                        :rules="[rules.required]"
                        label="Your Name"
                        name="name"
                        required>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        dense
                        v-model="contact.email"
                        :rules="rules.email"
                        label="E-mail"
                        name="email"
                        required>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-text-field
                        dense
                        v-model="contact.subject"
                        :rules="[rules.required]"
                        label="Subject"
                        name="email"
                        required>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-textarea
                        dense
                        name="message"
                        label="Message"
                        placeholder="Type your message"
                        counter
                        rows="3"
                        v-model="contact.message"
                        :rules="[rules.required]">
                      </v-textarea>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-btn
                        type="submit"
                        large
                        block
                        :loading="loading.contact"
                        :disabled="loading.contact || !formin.valid"
                        :color="maincolor"
                        class="mr-4 white--text">
                        Send Now
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Contact',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      contact: false,
      regnew: false,
    },
    api: process.env.VUE_APP_API,
    apptitle: process.env.VUE_APP_TITLE,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    datepick: {
      date: new Date().toISOString().substr(0, 10),
      tgllahir: false,
    },
    publickey: '123',
    contact: {
      name: '',
      email: '',
      subject: '',
      message: '',
    },
    formin: {
      password: false,
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => v.length >= 6 || 'Min 6 characters',
      nik: (v) => (v.length >= 16 || v === 'majujaya') || 'Min 16 characters',
      phone: (v) => (!!v && v.length <= 12) || 'Max 12 characters',
      email: [
        (v) => !!v || 'E-mail is required',
        (v) => (!!v && /.+@.+\..+/.test(v)) || 'E-mail must be valid',
      ],
      files: [
        (value) => !value || value.size < 1000000 || 'File kurang dari 1 MB!',
        (value) => !!value || 'Required.',
      ],
    },
    word: 'Vue',
    dmodal: {
      register: false,
    },
    regflag: false,
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
    ]),
  },
  watch: {
    'datepick.tgllahir'(val) {
      if (val) {
        setTimeout(() => (this.$refs.birthday.activePicker = 'YEAR'));
      }
    },
  },
  created: () => ({
  }),
  mounted() {
    // console.log('1');
  },
  methods: {
    submitContact() {
      this.alertdata.show = false;
      if (this.$refs.formcontact.validate()) {
        this.loading.contact = true;
        this.axios
          .post(
            this.api + '/public/contact',
            qs.stringify(
              this.contact,
            ),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.publickey,
              },
            },
          )
          .then((res) => {
            this.alertdata.show = true;
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                if (resdata.data.data === 1) {
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Thank you for getting in touch!';
                } else {
                  this.alertdata.type = 'error';
                  this.alertdata.text = 'Sorry we get error in your sending email, please try again!';
                }
              } else {
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.contact = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
            this.loading.contact = false;
          });
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
